import { Component, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';

interface Breadcrumb {
   label: string;
   url: string;
}

@Component({
   selector: 'app-breadcrumb-header',
   templateUrl: './breadcrumb-header.component.html',
   styleUrls: ['./breadcrumb-header.component.scss']
})
export class BreadcrumbHeaderComponent implements OnDestroy {
   private readonly destroy$ = new Subject<void>();
   @Input() rootRoute: string = "/";
   @Input() rootLabel: string = "";

   childLabel = '';

   constructor(private router: Router, private route: ActivatedRoute) { }

   ngOnInit() {
      this.childLabel = this.buildBreadcrumbs(this.route);
      this.router.events.pipe(filter((e) => e instanceof NavigationEnd), takeUntil(this.destroy$))
         .subscribe(() => {
            this.childLabel = this.buildBreadcrumbs(this.route);
         });
   }

   ngOnDestroy() { this.destroy$.next(); this.destroy$.complete(); }

   private buildBreadcrumbs(route: ActivatedRoute, url: string = '', crumbs: Breadcrumb[] = []) {
      let current = route;
      let label = '';
      while (current.firstChild) {
         current = current.firstChild;
         const data = current.snapshot.data;
         if (data && data['breadcrumb']) label = data['breadcrumb'];
      }
      return label;
   }
} 